const BaseMap = {
    STANDARD: 'se_basemap',
    STREET: 'mapbox_street_map',
    SATELLITE: 'satellite',
};

export default BaseMap;
